// Palette de couleurs assignées aux techniciens
// Orange (#F97316, #F59E0B) exclu — réservé aux journées résidences dans le calendrier
// Grille 5×5 = 25 couleurs
export const TECH_COLORS = [
  // Bleus
  "#0EA5E9",
  "#38BDF8",
  "#0284C7",
  "#3B82F6",
  "#1D4ED8",
  // Verts
  "#10B981",
  "#22C55E",
  "#84CC16",
  "#14B8A6",
  "#0F766E",
  // Rouges / roses / fuchsia
  "#EF4444",
  "#F43F5E",
  "#FB7185",
  "#EC4899",
  "#DB2777",
  // Violets
  "#6366F1",
  "#8B5CF6",
  "#A855F7",
  "#7C3AED",
  "#C026D3",
  // Divers
  "#06B6D4",
  "#0891B2",
  "#EAB308",
  "#64748B",
  "#475569",
]

export const FONT_SANS = "var(--font-sans), DM Sans, sans-serif"
export const FONT_MONO = "var(--font-mono), JetBrains Mono, monospace"
export const FONT_HEADING = "var(--font-heading), Syne, sans-serif"

// Seuil en minutes après lequel la position d'un technicien est considérée inconnue
// (si le gap entre la fin du RDV précédent et le début du nouveau dépasse cette valeur,
// on ne suppose pas que le tech est encore sur place)
export const POSITION_KNOWN_MIN = 25
